import { Injectable, InjectionToken, Provider } from '@angular/core';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiIntegrationServiceOffice } from '../api-types/integration-office.api';
import { IntegrationServiceOffice } from '../app-types/integration-office.app';
import {
	transformApiIntegrationOfficesToAppIntegrationOffices,
	transformApiIntegrationOfficeToAppIntegrationOffice,
} from '../transformers/integration-office.transform';
import { BaseRequestService } from './base-request.service';

export const INTEGRATION_OFFICE_SERVICE = new InjectionToken<IntegrationServiceOfficeService>(
	'INTEGRATION_OFFICE_SERVICE',
);

/**
 * Fetches everything related to integration service offices from the API.
 */
@Injectable()
export class IntegrationServiceOfficeService extends BaseRequestService {
	public async getAll(offset?: number, range?: number) {
		const params = offset === undefined && range === undefined ? undefined : { offset, range };
		const response = params
			? await this.get<PaginatedResponse<ApiIntegrationServiceOffice>>('integrationServiceOffices', params)
			: await this.get<PaginatedResponse<ApiIntegrationServiceOffice>>('integrationServiceOffices');
		const offices = transformApiIntegrationOfficesToAppIntegrationOffices(response.entities);
		const page: PaginatedResponse<IntegrationServiceOffice> = {
			entities: offices,
			offset: response.offset,
			range: response.range,
			totalEntities: response.totalEntities,
		};

		return page;
	}

	public async getById(id: number | string) {
		const response = await this.get<ApiIntegrationServiceOffice>(`integrationServiceOffices/${id}`);
		return transformApiIntegrationOfficeToAppIntegrationOffice(response);
	}
}

export const provideIsoApi: Provider = {
	provide: INTEGRATION_OFFICE_SERVICE,
	useClass: IntegrationServiceOfficeService,
};
